let dialogHandler = null;

export function registerVexaDialogHandler(handler) {
  dialogHandler = handler;

  return () => {
    if (dialogHandler === handler) {
      dialogHandler = null;
    }
  };
}

function requestDialog(request) {
  return new Promise(resolve => {
    if (!dialogHandler) {
      resolve(request.kind === "prompt" ? null : false);
      return;
    }

    dialogHandler({ ...request, resolve });
  });
}

export function requestVexaConfirm(message, options = {}) {
  return requestDialog({
    kind: "confirm",
    message: String(message ?? ""),
    ...options
  });
}

export function requestVexaPrompt(message, options = {}) {
  return requestDialog({
    kind: "prompt",
    message: String(message ?? ""),
    ...options
  });
}
